import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApisMembersInsightPostCommentsInsightPostWithCommentsShowResponseType } from "~/domains";

type RequestDataType = {
  insightPostId: string;
};

const request = async ({
  insightPostId,
}: RequestDataType): Promise<ApisMembersInsightPostCommentsInsightPostWithCommentsShowResponseType> => {
  const response =
    await new ApiClient().get<ApisMembersInsightPostCommentsInsightPostWithCommentsShowResponseType>(
      `/api/members/insight_posts/${insightPostId}/insight_post_with_comments`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  insightPostId: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisInsightPostsInsightPostWithCommentsShow = ({
  insightPostId,
  config = {},
}: PropsType): UseQueryResult<ApisMembersInsightPostCommentsInsightPostWithCommentsShowResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [
      "ApisMembersInsightPostsInsightPostWithCommentsShow",
      insightPostId,
    ],
    queryFn: () => request({ insightPostId }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
